import React from 'react';
import { ListItem } from 'material-ui/List';
import { FormattedDate, FormattedTime } from "react-intl";
import { DateStyles } from "../../constants/CentricConstants";


const RegistrationHistoryListItem = ({score, dateUpdated}) => {
    return (
        <ListItem
            primaryText = {(
                <span>
                    <strong>{score}%</strong> <em>on <FormattedDate value={dateUpdated} {...DateStyles.long} /> at <FormattedTime value={dateUpdated} /></em>
                </span>
            )}
        />
    );
};

export default RegistrationHistoryListItem;
